import gql from 'graphql-tag';

export default gql`
  fragment unsubscribeAutomaticMailProspectActivityFragment on UnsubscribeAutomaticMailProspectActivity {
    id
  }
`;
